import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EvaluationsDashboard from '../components/EvaluationsDashboard';
import CertificationNav from '../components/CertificationNav';
import { useTranslation } from '../translations';

/**
 * EvaluationsPage - Página dedicada para o Dashboard de Avaliações
 * 
 * Wrapper que permite acesso direto via rota /evaluations
 * Similar à página /certification
 * 
 * Tripé HeveaTalent:
 * - Justiça: Acesso direto às avaliações
 * - Segurança: Verificação de autenticação
 * - Simplicidade: Navegação clara e direta
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const EvaluationsPage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          navigate('/');
          return;
        }

        const response = await fetch(`${BACKEND_URL}/api/me`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
        } else {
          navigate('/');
        }
      } catch (error) {
        console.error('Erro ao carregar usuário:', error);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, [navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600">{t('certLoading')}</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <>
      <CertificationNav />
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 py-8">
        <div className="container mx-auto px-4 max-w-6xl">
          <EvaluationsDashboard user={user} />
        </div>
      </div>
    </>
  );
};

export default EvaluationsPage;
